const digest = 'ad42a9109d5656177ab306d862f0970b992a6cdb919f1de4f705675da331c66f';
const css = `._popup_5aov5_1{z-index:100}._popup_5aov5_1>div>div{border-radius:0;height:100%;margin:0;max-height:unset;max-width:unset!important;width:100%}._popup_5aov5_1>div>div>div{height:100%;max-height:unset!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'popup': '_popup_5aov5_1' };
export const popup = '_popup_5aov5_1';
export { css, digest };